import { BaseDevice } from "./base.device";
import { IShare, ITitle, IWindow, NavigationBar, UserLocation } from "./model";
import { Itoken } from "../auth";
import { from, Observable, of } from "rxjs";
import { TokenService } from "../token/token.service";
import { UserService } from "../user/user.service";
import { HttpClient } from "@angular/common/http";
import { BASE_CLIENT, BaseClient } from "../client/base.client";
import { Inject, Injectable } from "@angular/core";
import { preloaderFinished } from "../auth/preloader";
import { Title } from "@angular/platform-browser";

const apis = [
  "updateAppMessageShareData",
  "updateTimelineShareData",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "onMenuShareQQ",
  "onMenuShareWeibo",
  "onMenuShareQZone",
  "startRecord",
  "stopRecord",
  "onVoiceRecordEnd",
  "playVoice",
  "pauseVoice",
  "stopVoice",
  "onVoicePlayEnd",
  "uploadVoice",
  "downloadVoice",
  "chooseImage",
  "previewImage",
  "uploadImage",
  "downloadImage",
  "translateVoice",
  "getNetworkType",
  "openLocation",
  "getLocation",
  "hideOptionMenu",
  "showOptionMenu",
  "hideMenuItems",
  "showMenuItems",
  "hideAllNonBaseMenuItem",
  "showAllNonBaseMenuItem",
  "closeWindow",
  "scanQRCode",
  "chooseWXPay",
  "openProductSpecificView",
  "addCard",
  "chooseCard",
  "openCard",
];

const openTags = [
  'wx-open-launch-weapp',
  'wx-open-launch-app',
  'wx-open-subscribe',
  'wx-open-audio'
];

declare let wx;

@Injectable({
  providedIn: "root",
})
export class WechatMicro extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    private title: Title,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  auth(): Promise<any> {
    if (this.baseclient.wechatMicro && this.baseclient.wechatMicro.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    return new Promise<any>((resolve, reject) => {
      const tokenInfo: any = {};
      tokenInfo.account = this.getUrlParam('account');
      tokenInfo.accessToken = this.getUrlParam('accessToken');
      tokenInfo.userId = this.getUrlParam('userId');
      tokenInfo.tokenType = 'bearer';
      this.tokenService.set(tokenInfo as any);
      this.http
        .get(`${this.baseclient.gateway}/auth/user`)
        .subscribe((response: any) => {
          // 设置user
          this.user.set(response.principal);
          this.generateWechatConfig();
          // 加载结束
          preloaderFinished();
          resolve(true);
        });
    });
  }

  generateWechatConfig(): void {
    this.http
      .get(`${this.baseclient.gateway}/wechat/mp/jssdk?url=${encodeURIComponent(window.location.href)}`)
      .subscribe((response: any) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: response.appId, // 必填，公众号的唯一标识
          timestamp: response.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.nonceStr, // 必填，生成签名的随机串
          signature: response.signature, // 必填，签名
          jsApiList: apis, // 必填，需要使用的JS接口列表
          openTagList: openTags // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
      });
    wx.ready(() => {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，
      // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      console.log('微信jssdk初始化完成.');
    });

    wx.error((res) => {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('微信jssdk初始化失败:', res);
    });
  }

  openWindow(iwindow: IWindow): void {
    window.location.href = iwindow.url;
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("小程序暂不支持放置按钮,请在APP中使用此功能!");
  }

  share(ishare: IShare): void {
    alert("小程序暂不支持分享,请在APP中使用此功能!");
  }

  getToken(): Itoken {
    const itoken: Itoken = {
      accessToken: this.tokenService.get().accessToken,
      tokenType: null,
      tokenDataLine: null,
      scope: null,
    };
    return itoken;
  }

  scanCode(): Observable<string> {
    const p = new Promise<string>((resolve, reject) => {
      wx.scanQRCode({
        needResult: 1,
        scanType: ['qrCode', 'barCode'],
        success: (res: any) => {
          resolve(res.resultStr);
        },
      });
    });
    return from(p);
  }

  userLocation(): Observable<UserLocation> {
    const p = new Promise<UserLocation>((resolve, reject) => {
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success(res: any) {
          if (res.errMsg === 'getLocation:ok') {
            const latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            const longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            const address = '微信无address';
            resolve({latitude, longitude, address});
          }
        },
      });
    });
    return from(p);
  }

  validateInWifi(bssids: string[]): Observable<boolean> {
    alert("小程序暂不支持WIFI验证,请在APP中使用此功能!");
    return undefined;
  }

  getWifiMac(): Observable<string> {
    alert("小程序暂不支持获取MAC地址,请在APP中使用此功能!");
    return undefined;
  }

  chooseContacts(count: number): Observable<any> {
    alert("小程序暂不支持获取联系人,请在APP中使用此功能!");
    return undefined;
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("小程序暂不支持查询联系人详细信息,请在APP中使用此功能!");
    return undefined;
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert("小程序暂不支持图片上传,请在APP中使用此功能!");
    return undefined;
  }

  openReadWithTimer(
    url: any,
    openType: any,
    title: any,
    id: any,
    type: any
  ): Observable<any> {
    alert("小程序暂不支持读物时间统计,请在APP中使用此功能!");
    return undefined;
  }

  uploadMovie(limitMinute: number): Observable<any> {
    alert("小程序暂不支持视频上传,请在APP中使用此功能!");
    return undefined;
  }

  fileBrowser(url: string, title: string): Observable<any> {
    alert("小程序暂不支持此功能,请在APP中使用此功能!");
    return undefined;
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    wx.startSearchBeacons({
      ticket: ticket,
      complete: callback,
    });
  }
  stopSearchBeacons(callback: (argv: any) => void): void {
    wx.stopSearchBeacons({
      complete: callback,
    });
  }
  onSearchBeacons(callback: (argv: any) => void): void {
    wx.onSearchBeacons({
      complete: callback,
    });
  }

  // 封装方法: 获取url中的参数
  private getUrlParam(name): string {
    // 构造一个含有目标参数的正则表达式对象
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const strings = window.location.href.split('?');
    // 匹配目标参数
    const r = strings[strings.length - 1].match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  }
}
